/* OGT WELCOME PACK - assets/ogt-welcome-pack.js
   Behaviour for sections/ogt-welcome-pack.liquid and its blocks (built 16 Oct 2026):
   - the photo gallery (thumbnails switch the main photo)
   - the plan block: boxes + frequency choice, live "then" price, T-shirt size,
     and adding the pack to the basket on its Skio subscription plan
   - the product details block: flavour switch, nutrition text turned into a figures grid

   It does not touch assets/ogt-page.js. It uses window.OGT.openCartSidebar() from
   that file when present, and otherwise goes to the basket page.
   Every element is found fresh on each init, and the theme editor's section and
   block events re-run it, so a re-render never leaves a dead control. */
(function () {
  'use strict';

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '£' + (v.slice(-3) === '.00' ? v.slice(0, -3) : v);
  }

  function pressOnly(group, btn) {
    group.querySelectorAll('[aria-pressed]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b === btn));
    });
  }

  /* ---- gallery ----
     On a page with two ranges each range has its own gallery (.ogt-wp__gal), so the
     thumbnails only switch the photos in their own gallery. */
  function initGallery(root) {
    root.querySelectorAll('.ogt-wp__thumbs').forEach(function (thumbs) {
      if (thumbs.__ogtWp) return;
      thumbs.__ogtWp = true;
      var scope = thumbs.closest('.ogt-wp__gal') || root;
      thumbs.addEventListener('click', function (e) {
        var b = e.target.closest('[data-thumb]');
        if (!b) return;
        var n = b.getAttribute('data-thumb');
        pressOnly(thumbs, b);
        scope.querySelectorAll('.ogt-wp__slide').forEach(function (s) {
          if (s.getAttribute('data-slide') === n) s.setAttribute('data-cur', '1');
          else s.removeAttribute('data-cur');
        });
      });
    });
  }

  /* ---- plan, size and basket ---- */
  function planState(plan) {
    return {
      boxes: parseInt(plan.dataset.boxes, 10) || 1,
      weeks: parseInt(plan.dataset.weeks, 10) || 4,
      size: plan.dataset.size || '',
      box: parseInt(plan.dataset.box, 10) || 0,
      bars: parseInt(plan.dataset.bars, 10) || 12
    };
  }

  function boxesText(n, bars) {
    return n + (n === 1 ? ' box' : ' boxes') + ' (' + n * bars + ' bars)';
  }

  /* Ticks live in their own blocks but sit inside the plan card, so they are
     updated across the whole buy box. */
  function refreshPlan(plan) {
    var st = planState(plan);
    var scope = plan.closest('[data-ogt-wp]') || plan;
    var orderPrice = st.box ? money(st.box * st.boxes) : '';
    scope.querySelectorAll('[data-wp-boxes-text]').forEach(function (el) { el.textContent = boxesText(st.boxes, st.bars); });
    scope.querySelectorAll('[data-wp-weeks]').forEach(function (el) { el.textContent = String(st.weeks); });
    if (orderPrice) scope.querySelectorAll('[data-wp-order-price]').forEach(function (el) { el.textContent = orderPrice; });
    var refill = plan.querySelector('[data-wp-refill]');
    if (refill) refill.textContent = boxesText(st.boxes, st.bars) + ' every ' + st.weeks + ' weeks';
  }

  function showSizeMessage(plan, on) {
    var msg = plan.querySelector('[data-wp-sizemsg]');
    if (!msg) return;
    msg.textContent = on ? plan.dataset.sizemsg || 'Choose a size first' : '';
    msg.style.display = on ? '' : 'none';
  }

  function addToBasket(plan, btn) {
    if (plan.__ogtBusy) return;
    var st = planState(plan);
    var needsSize = !!plan.querySelector('[data-pick-size]');
    if (needsSize && !st.size) {
      showSizeMessage(plan, true);
      var first = plan.querySelector('[data-pick-size]');
      if (first) first.focus();
      return;
    }
    if (!plan.dataset.variant) {
      setLabel(btn, 'Unavailable');
      return;
    }
    var props = {};
    if (needsSize) props[plan.dataset.psize || 'T-shirt size'] = st.size;
    if (plan.querySelector('[data-pick-boxes]')) {
      props[plan.dataset.pboxes || 'Boxes after welcome pack'] = String(st.boxes);
      props[plan.dataset.pweeks || 'Deliver every'] = st.weeks + ' weeks';
    }
    var item = { id: Number(boxesVariant(plan, st.boxes) || plan.dataset.variant), quantity: 1, properties: props };
    // the Skio plan follows the chosen frequency, so 2 weeks is billed every 2 weeks (22 Oct 2026)
    var planId = (st.weeks === 2 && plan.dataset.plan2) || (st.weeks === 4 && plan.dataset.plan4) || plan.dataset.plan;
    if (planId) item.selling_plan = Number(planId);

    plan.__ogtBusy = true;
    btn.disabled = true;
    var label = btn.querySelector('[data-wp-label]');
    var idle = label ? label.textContent : '';
    if (label) label.textContent = 'Adding…';

    var addUrl = (plan.dataset.cartAdd || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        if (plan.querySelector('[data-pick-boxes]')) return setBoxesNote(st.boxes);
      })
      .then(function () {
        var open = window.OGT && window.OGT.openCartSidebar;
        return (open ? open() : Promise.resolve(false)).then(function (opened) {
          if (!opened) window.location.href = plan.dataset.cartUrl || '/cart';
        });
      })
      .catch(function () {
        if (label) label.textContent = 'Couldn’t add — try again';
        setTimeout(function () { if (label) label.textContent = idle; }, 2400);
      })
      .then(function () {
        plan.__ogtBusy = false;
        btn.disabled = false;
        if (label && label.textContent === 'Adding…') label.textContent = idle;
      });
  }

  /* data-box-variants is "1:id,2:id,3:id" when the pack has a Boxes option; the variant
     for the boxes picked goes in the basket. Without one, the pack's own variant is used. */
  function boxesVariant(plan, boxes) {
    var pairs = (plan.dataset.boxVariants || '').split(',');
    for (var i = 0; i < pairs.length; i++) {
      var kv = pairs[i].split(':');
      if (parseInt(kv[0], 10) === boxes && kv[1]) return kv[1];
    }
    return '';
  }

  /* The box count goes in the order note as wp-boxes-1/2/3, so a Skio journey can read it
     straight away with a "Subscription note" condition, with no Shopify Flow (23 Oct 2026).
     Any other note text is kept; an earlier wp-boxes-N is replaced. A failed note never
     stops the pack going in the basket. */
  function setBoxesNote(boxes) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var headers = { Accept: 'application/json', 'Content-Type': 'application/json' };
    return fetch(root + 'cart.js', { headers: headers })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var rest = String(cart.note || '').replace(/\s*wp-boxes-\d+\s*/g, ' ').trim();
        var note = (rest ? rest + ' ' : '') + 'wp-boxes-' + boxes;
        return fetch(root + 'cart/update.js', { method: 'POST', headers: headers, body: JSON.stringify({ note: note }) });
      })
      .catch(function () {});
  }

  function setLabel(btn, text) {
    var label = btn.querySelector('[data-wp-label]');
    if (label) label.textContent = text;
  }

  function initPlan(plan) {
    if (plan.__ogtWp) { refreshPlan(plan); return; }
    plan.__ogtWp = true;
    plan.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick-boxes],[data-pick-weeks],[data-pick-size],[data-wp-add],[data-wp-onetime]');
      if (!b) return;
      if (b.hasAttribute('data-wp-add')) { e.preventDefault(); addToBasket(plan, b); return; }
      if (b.hasAttribute('data-wp-onetime')) { e.preventDefault(); return; }
      var group = b.closest('[role="group"]') || b.parentNode;
      pressOnly(group, b);
      if (b.hasAttribute('data-pick-boxes')) plan.dataset.boxes = b.getAttribute('data-pick-boxes');
      if (b.hasAttribute('data-pick-weeks')) plan.dataset.weeks = b.getAttribute('data-pick-weeks');
      if (b.hasAttribute('data-pick-size')) { plan.dataset.size = b.getAttribute('data-pick-size'); showSizeMessage(plan, false); }
      refreshPlan(plan);
    });
    refreshPlan(plan);
  }

  /* ---- product details ---- */
  var NUTRIENTS = [
    ['Energy', /Energy\s*([\d.,]+)\s*\(?kJ\)?\s*\/\s*([\d.,]+)\s*\(?kcal\)?/i, 0],
    ['Fat', /Fat\s*([\d.]+\s*g)/i, 0],
    ['of which saturates', /saturates\s*([\d.]+\s*g)/i, 1],
    ['Carbohydrates', /Carbohydrates?\s*([\d.]+\s*g)/i, 0],
    ['of which sugars', /sugars\s*([\d.]+\s*g)/i, 1],
    ['Fibre', /Fibre\s*([\d.]+\s*g)/i, 0],
    ['Protein', /Protein\s*([\d.]+\s*g)/i, 0],
    ['Salt', /Salt\s*([\d.]+\s*g)/i, 0]
  ];
  /* Optional groups (Performance² has them, Original² does not). A group is shown
     only when every row in it reads cleanly from both halves. */
  var AMOUNT = '([\\d.]+\\s*(?:mg|µg|mcg|g)(?:\\s*\\(\\s*\\d+\\s*%\\s*RI\\s*\\*?\\s*\\))?)';
  var EXTRA_GROUPS = [
    ['Electrolytes', ['Sodium', 'Potassium', 'Calcium', 'Magnesium']],
    ['Vitamins', ['Vitamin C', 'Vitamin E', 'Vitamin B6', 'Vitamin B12']]
  ];

  function extraRows(a, b) {
    var out = [];
    for (var g = 0; g < EXTRA_GROUPS.length; g++) {
      var rows = [];
      var names = EXTRA_GROUPS[g][1];
      for (var i = 0; i < names.length; i++) {
        var re = new RegExp(names[i].replace(/ /g, '\\s*') + '(?![\\d])\\s*' + AMOUNT, 'i');
        var x = a.match(re);
        var y = b.match(re);
        if (!x || !y) { rows = null; break; }
        rows.push('<tr class="ogt-wpd__sub"><th scope="row">' + names[i] + '</th><td>' + riText(x[1]) + '</td><td>' + riText(y[1]) + '</td></tr>');
      }
      if (rows) out.push('<tr><th scope="rowgroup" colspan="3">' + EXTRA_GROUPS[g][0] + '</th></tr>' + rows.join(''));
    }
    return out.join('');
  }

  function riText(v) {
    return v.replace(/\s+/g, '').replace(/\((\d+)%RI\*?\)/i, ' ($1% RI*)');
  }

  /* The flavour products hold nutrition as two sentences: "per 100g: ..." and
     "per 55g bar: ...". When both halves read cleanly they become a grid; when
     they do not, the text is left exactly as typed rather than guessed at. */
  function nutritionGrid(el) {
    if (el.__ogtGrid) return;
    el.__ogtGrid = true;
    var txt = (el.textContent || '').replace(/\s+/g, ' ');
    var cut = txt.search(/per\s*\d+\s*g\s*bar/i);
    var start = txt.search(/per\s*100\s*g/i);
    if (cut < 0 || start < 0) return;
    var a = txt.slice(start, cut);
    var b = txt.slice(cut);
    var barLabel = (b.match(/per\s*\d+\s*g\s*bar/i) || ['Per bar'])[0];
    var rows = [];
    for (var i = 0; i < NUTRIENTS.length; i++) {
      var n = NUTRIENTS[i];
      var x = a.match(n[1]);
      var y = b.match(n[1]);
      if (!x || !y) return;
      var fmt = function (m) { return m[2] ? m[1] + ' kJ / ' + m[2] + ' kcal' : m[1].replace(/\s+/g, ''); };
      rows.push('<tr' + (n[2] ? ' class="ogt-wpd__sub"' : '') + '><th scope="row">' + n[0] + '</th><td>' + fmt(x) + '</td><td>' + fmt(y) + '</td></tr>');
    }
    var extra = extraRows(a, b);
    var foot = (txt.match(/\*\s*Reference intake[^*]*$/i) || [''])[0].trim();
    var name = el.getAttribute('data-nutrition') || '';
    el.innerHTML =
      '<table class="ogt-wpd__grid"><caption style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap">Nutritional information, ' +
      name.replace(/</g, '&lt;') + '</caption><thead><tr><th scope="col">' + name.replace(/</g, '&lt;') +
      '</th><th scope="col">Per 100g</th><th scope="col">' + barLabel.replace(/^per/i, 'Per') + '</th></tr></thead><tbody>' + rows.join('') + extra + '</tbody></table>' +
      (foot ? '<p class="ogt-wpd__foot">' + foot.replace(/</g, '&lt;') + '</p>' : '');
  }

  function initDetails(det) {
    det.querySelectorAll('[data-nutrition]').forEach(nutritionGrid);
    if (det.__ogtWp) return;
    det.__ogtWp = true;
    det.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick-flavour]');
      if (!b) return;
      var n = b.getAttribute('data-pick-flavour');
      /* both dropdowns follow the same flavour */
      det.querySelectorAll('[data-pick-flavour]').forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.getAttribute('data-pick-flavour') === n));
      });
      det.querySelectorAll('[data-flavour]').forEach(function (p) {
        if (p.getAttribute('data-flavour') === n) p.setAttribute('data-cur', '1');
        else p.removeAttribute('data-cur');
      });
    });
  }

  /* ---- two ranges and one-time packs (16 Oct 2026, the international welcome pack) ----
     The range choice block (blocks/ogt_wp_range.liquid) carries each range's figures as
     "name|price|was|saving|saving_pct|per_bar". Choosing a range sets data-wp-range on the
     buy box (CSS shows that range's words and photos) and presses every matching button
     on the page: the range block, the switches inside the product details, and the sticky
     bar's pills whose key is "wp1" / "wp2". The sticky bar's own words were rendered for the
     range the page opened on; they are re-written by swapping one range's figures for the
     other's, so no copy lives in this script. Lines outside the buy box (the announcement
     bar) are marked data-wp-swap and get the same treatment, prices only: a sentence can
     name both ranges, and the range name must stay put. */
  function rangeBlock() { return document.querySelector('[data-ogt-wp-range]'); }

  function rangeVals(n) {
    var rb = rangeBlock();
    var raw = rb ? rb.getAttribute('data-wp-vals-' + n) || '' : '';
    return raw.split('|');
  }

  function swapVals(text, from, to) {
    /* longest first, so "€110" is never caught inside a longer figure */
    var pairs = [];
    for (var i = 0; i < from.length; i++) {
      if (from[i] && to[i] !== undefined && from[i] !== to[i]) pairs.push([from[i], to[i]]);
    }
    pairs.sort(function (a, b) { return b[0].length - a[0].length; });
    var out = text;
    pairs.forEach(function (p) { out = out.split(p[0]).join('\u0000' + pairs.indexOf(p) + '\u0000'); });
    pairs.forEach(function (p, i) { out = out.split('\u0000' + i + '\u0000').join(p[1]); });
    return out;
  }

  function syncBar(n) {
    var bar = document.getElementById('buybar');
    var rb = rangeBlock();
    if (!bar || !rb) return;
    var start = rb.getAttribute('data-wp-start') || '1';
    var from = rangeVals(start);
    var to = rangeVals(n);
    /* text node by text node, so a crossed-out price (<s>) inside a line keeps its markup */
    ['#bbName', '#bbPrice', '.ogt-bb-cta'].forEach(function (sel) {
      var el = bar.querySelector(sel);
      if (!el) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      for (var node = walker.nextNode(); node; node = walker.nextNode()) {
        if (node.__ogtWpOrig === undefined) node.__ogtWpOrig = node.nodeValue;
        node.nodeValue = swapVals(node.__ogtWpOrig, from, to);
      }
    });
  }

  function setRange(n) {
    n = String(n);
    if (n !== '1' && n !== '2') return;
    document.querySelectorAll('[data-ogt-wp][data-wp-range]').forEach(function (r) { r.setAttribute('data-wp-range', n); });
    var rb = rangeBlock();
    if (rb) rb.setAttribute('data-wp-cur', n);
    document.querySelectorAll('[data-wp-pick-range]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-wp-pick-range') === n));
    });
    document.querySelectorAll('#buybar .ogt-bb-pill[data-bbrange^="wp"]').forEach(function (p) {
      p.setAttribute('aria-pressed', String(p.getAttribute('data-bbrange') === 'wp' + n));
    });
    syncBar(n);
    syncShared(n);
  }

  /* Shared lines rendered once, for the range the page opened on. Prices only (slice off the name). */
  function syncShared(n) {
    var rb = rangeBlock();
    if (!rb) return;
    var start = rb.getAttribute('data-wp-start') || '1';
    var from = rangeVals(start).slice(1);
    var to = rangeVals(n).slice(1);
    document.querySelectorAll('[data-wp-swap]').forEach(function (el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      for (var node = walker.nextNode(); node; node = walker.nextNode()) {
        if (node.__ogtWpOrig === undefined) node.__ogtWpOrig = node.nodeValue;
        node.nodeValue = swapVals(node.__ogtWpOrig, from, to);
      }
    });
  }

  function currentRange() {
    var rb = rangeBlock();
    return rb ? rb.getAttribute('data-wp-cur') || '1' : '1';
  }

  /* The variant for a range comes from the one-time card's own button for that range. */
  function rangeVariant(n) {
    var b = document.querySelector('[data-ogt-wp-onetime] [data-wp-add-range="' + n + '"][data-variant]');
    return b ? b.getAttribute('data-variant') : '';
  }

  function addOnce(btn, variant) {
    var card = document.querySelector('[data-ogt-wp-onetime]');
    if (!variant || !card || card.__ogtBusy) return;
    var label = btn.querySelector('[data-wp-label]') || btn;
    var idle = label.textContent;
    var msg = card.querySelector('[data-wp-msg]');
    card.__ogtBusy = true;
    btn.disabled = true;
    label.textContent = '…';
    fetch((card.dataset.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        var open = window.OGT && window.OGT.openCartSidebar;
        return (open ? open() : Promise.resolve(false)).then(function (opened) {
          if (!opened) window.location.href = card.dataset.cartUrl || '/cart';
        });
      })
      .catch(function (err) {
        /* Shopify's own message (already in the shopper's language) when there is one */
        if (msg) {
          msg.textContent = (err && (err.description || err.message)) || '';
          msg.style.display = msg.textContent ? '' : 'none';
        }
      })
      .then(function () {
        card.__ogtBusy = false;
        btn.disabled = false;
        label.textContent = idle;
      });
  }

  function initRanges() {
    if (!document.__ogtWpRanges) {
      document.__ogtWpRanges = true;
      document.addEventListener('click', function (e) {
        var pick = e.target.closest('[data-wp-pick-range]');
        if (pick) { setRange(pick.getAttribute('data-wp-pick-range')); return; }
        var add = e.target.closest('[data-wp-add-range]');
        if (add) {
          e.preventDefault();
          var n = add.getAttribute('data-wp-add-range');
          if (!add.closest('[data-ogt-wp-onetime]')) setRange(n);
          addOnce(add, add.getAttribute('data-variant') || rangeVariant(n));
        }
      });
      /* Sticky bar: capture phase, so these run before assets/ogt-page.js's own handlers,
         which only know the homepage offer module. Only on a page with a range choice. */
      document.addEventListener('click', function (e) {
        if (!rangeBlock()) return;
        var pill = e.target.closest('#buybar .ogt-bb-pill[data-bbrange^="wp"]');
        if (pill) { setRange(pill.getAttribute('data-bbrange').slice(2)); return; }
        var cta = e.target.closest('#buybar .ogt-bb-cta');
        if (cta && document.querySelector('[data-ogt-wp-onetime]')) {
          e.preventDefault();
          e.stopPropagation();
          addOnce(cta, rangeVariant(currentRange()));
        }
      }, true);
    }
    var rb = rangeBlock();
    if (rb) {
      if (!rb.getAttribute('data-wp-start')) rb.setAttribute('data-wp-start', rb.getAttribute('data-wp-cur') || '1');
      setRange(currentRange());
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ogt-wp]').forEach(initGallery);
    (root || document).querySelectorAll('[data-ogt-wp-plan]').forEach(initPlan);
    (root || document).querySelectorAll('[data-ogt-wp-details]').forEach(initDetails);
    initRanges();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function () { init(); });
})();
